import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, MenuItem, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';

// project imports
import { MENU_OPEN, SET_MENU, SET_SELECTED_NAV_ITEM } from 'store/actions';
import config from 'config';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { SHOW_NOT_SUBSCRIBED, SHOW_NOT_VALIDATED, SHOW_NOT_SUBSCRIBED_NON_CREATOR } from 'store/Authentication/actions';
import { useLazyQuery } from '@apollo/client';
import { GET_TOTAL_UNREAD_QUESTION } from 'schemas/query';
import PermisssionViewValidationWrapper from 'Components/PermissionWrapper/PermissionViewValidationWrapper';

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level, drawerOpen }) => {
    const [totalUnreadQuestion, setTotalUnreadQuestion] = useState(0);
    const [questionChip, setQuestionChip] = useState(false);
    const [totalPromotQuestion, setTotalPromotQuestion] = useState(0);
    const [promptChip, setPromptChip] = useState(false);
    const location = useLocation();
    const theme = useTheme();
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);
    const selectedItem = useSelector((state) => state.customization?.selectedNavItem);
    let companyId = null;
    let userDataParsed = null;
    const userData = localStorage.getItem('diologUserData');
    if (userData) {
        userDataParsed = JSON.parse(userData);
    }
    if (userDataParsed && userDataParsed.companyId) {
        companyId = userDataParsed.companyId;
    }
    const authentication = useSelector((state) => state.authentication);
    const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));
    const Icon = item.icon;
    const { hasAdministrativeControl, canManageQuestion } = authentication.permissions;
    let { hasSubscribed, companyValidated } = authentication;
    let urlData;
    const { companyCreator, navReload } = customization;
    if (hasSubscribed) {
        urlData = `${config.basename}${item.url}`;
    } else {
        urlData = `${config.basename}/dashboard`;
    }
    let hasPermission = true;
    // if (!hasAdministrativeControl) {
    //     if (item.id === 'our-faq') {
    //         hasPermission = false;
    //     }
    // }
    // if (!canManageQuestion) {
    //     if (item.id === 'question-registry' || item.id === 'questions') {
    //         hasPermission = false;
    //     }
    // }
    const itemIcon = item?.icon ? (
        <Icon stroke={1.5} size="1.3rem" />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
                height: customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    let itemTarget = '_self';
    if (item.target) {
        itemTarget = '_blank';
    }
    let listItemProps = {
        component: forwardRef((props, ref) => <Link ref={ref} {...props} to={urlData} target={itemTarget} />)
    };
    if (item?.external) {
        listItemProps = { component: 'a', href: item.url, target: itemTarget };
    }

    const itemHandler = (id) => {
        if (!hasSubscribed) {
            if (!companyCreator && !hasSubscribed) {
                dispatch({ type: SHOW_NOT_SUBSCRIBED_NON_CREATOR });
            } else {
                dispatch({ type: SHOW_NOT_SUBSCRIBED });
            }
        }
        dispatch({ type: MENU_OPEN, id });
        if (matchesSM) dispatch({ type: SET_MENU, opened: false });
        dispatch({ type: SET_SELECTED_NAV_ITEM, selectedItem: null });
    };
    let [getTotalUnread] = useLazyQuery(GET_TOTAL_UNREAD_QUESTION, {
        onCompleted: (result) => {
            if (item.id && item.id === 'questions') {
                let totalquestions = result.getTotalUnreadQuestions.total;
                if (totalquestions) {
                    setTotalUnreadQuestion(totalquestions);
                    setQuestionChip(true);
                } else {
                    setQuestionChip(false);
                }
            }
            // if (item.id && item.id === 'response-template') {
            //     let totalPrompt = result.getUnseenMonthlyQuestionCount.count;
            //     if (totalPrompt) {
            //         setTotalPromotQuestion(totalPrompt);
            //         setPromptChip(true);
            //     } else {
            //         setPromptChip(false);
            //     }
            // }
        }
    });
    useEffect(() => {
        if (companyId) {
            setTimeout(() => {
                getTotalUnread({ variables: { companyId: companyId } });
            }, 500);
        }
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === item.id);
        if (currentIndex > -1) {
            dispatch({ type: MENU_OPEN, id: item.id });
        }
    }, [location, navReload]);

    const activePage = (item) => {
        if (location.pathname === item.url) {
            return 'active';
        } else {
            if (item.id === 'default') {
                if (location.pathname === '/dashboard/history-of-activity') {
                    return 'active';
                }
                if (location.pathname === '/dashboard/notifications') {
                    return 'active';
                }
            }
            if (item.id === 'announcements') {
                if (location.pathname.includes('/dashboard/announcements/')) {
                    return 'active';
                }
            }
            if (item.id === 'my-team') {
                if (location.pathname.includes('/dashboard/my-team-details')) {
                    return 'active';
                }
            }
        }
    };

    return (
        <>
            <PermisssionViewValidationWrapper pageName={item.id} isNotNavigate={true}>
                <MenuItem>
                    <ListItemButton
                        {...listItemProps}
                        disabled={item.disabled}
                        sx={{
                            borderRadius: `${customization.borderRadius}px`,
                            mb: 0.5,
                            alignItems: 'flex-start',
                            backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                            py: level > 1 ? 1 : 1.25,
                            pl: `${level * 24}px`
                        }}
                        selected={customization.isOpen.findIndex((id) => id === item.id) > -1}
                        onClick={() => itemHandler(item.id)}
                        className={item.id === selectedItem ? 'active' : activePage(item)}
                    >
                        <ListItemIcon sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}>{itemIcon}</ListItemIcon>
                        {(drawerOpen || (!drawerOpen && level !== 1)) && (
                            <ListItemText
                                primary={
                                    <div
                                        variant={customization.isOpen.findIndex((id) => id === item.id) > -1 ? 'span' : 'body1'}
                                        color="inherit"
                                    >
                                        {item.title}

                                        {questionChip && item.id === 'questions' && totalUnreadQuestion && (
                                            <Chip size="small" label={totalUnreadQuestion} />
                                        )}

                                        {promptChip && item.id === 'question-registry' && totalPromotQuestion && (
                                            <Chip size="small" label={totalPromotQuestion} />
                                        )}
                                    </div>
                                }
                            />
                        )}
                    </ListItemButton>
                </MenuItem>
            </PermisssionViewValidationWrapper>
        </>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;
